import React from "react";
import { BadgePill } from "./Badge.styled";

/**
 * Generic colored pill badge.
 *
 * @param {string} text   — badge label
 * @param {string} color  — text color
 * @param {string} bg     — background color
 * @param {string} [border] — optional CSS border value
 */
const StatusBadge = ({ text, color, bg, border, ...rest }) => (
  <BadgePill $color={color} $bg={bg} $border={border} {...rest}>
    {text}
  </BadgePill>
);

export default StatusBadge;
